/* src/app/components/alert-modal/alert-modal.component.scss */
p {
  font-size: 18px;
  text-align: center;
  align-items: center;
  justify-content: center;
  min-height: 100px;
}
.closeDiv {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center flex-end;
  align-items: center;
  flex: 1 1 50px;
  max-height: 50px;
  min-height: 50px;
}
/*# sourceMappingURL=alert-modal.component-BRMUXV6K.css.map */
